// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1zBZJ","modalFooterButton":"ModalNotes_modalFooterButton__2fZir"};